import { Navigate, Route, Routes } from 'react-router-dom';
import AppShell from './layouts/AppShell';
// @ts-ignore
import ForgotPasswordPage from './pages/ForgotPasswordPage';
// @ts-ignore
import LandingPage from './pages/LandingPage';
// @ts-ignore
import LoginPage from './pages/LoginPage';
// @ts-ignore
import RegisterPage from './pages/RegisterPage';
// @ts-ignore
import DashboardPage from './pages/DashboardPage';
// @ts-ignore
import EmpresasPage from './pages/EmpresasPage';
// @ts-ignore
import EmpresaDetalhePage from './pages/EmpresaDetalhePage';
// @ts-ignore
import AgendaPage from './pages/AgendaPage';
// @ts-ignore
import AbertosPage from './pages/AbertosPage';
// @ts-ignore
import ExtracaoGooglePage from './pages/ExtracaoGooglePage';
// @ts-ignore
import KanbanPage from './pages/KanbanPage';
// @ts-ignore
import ExtracaoApoloPage from './pages/ExtracaoApoloPage';
// @ts-ignore
import AgentePage from './pages/AgentePage';
// @ts-ignore
import PerfilPage from './pages/PerfilPage';
// @ts-ignore
import ConfiguracoesPage from './pages/ConfiguracoesPage';
// @ts-ignore
import ConfigurarWhattsPage from './pages/ConfigurarWhattsPage';
// @ts-ignore
import BuscaAiPage from './pages/BuscaAiPage';
import PrivateRoute from './routes/PrivateRoute';
import { useAuth } from './store/authContext';

function GoogleExtractionRouteGuard() {
  const { session } = useAuth();
  const value = session?.user?.usa_extracao_google;

  const canAccess =
    typeof value === 'boolean'
      ? value
      : typeof value === 'number'
      ? value === 1
      : typeof value === 'string'
      ? !['false', '0', 'nao', 'não', 'no', 'off'].includes(value.trim().toLowerCase())
      : true;

  if (!canAccess) return <Navigate to="/dashboard" replace />;
  return <ExtracaoGooglePage />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />

      <Route element={<PrivateRoute />}>
        <Route element={<AppShell />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/empresas" element={<EmpresasPage />} />
          <Route path="/empresas/:id" element={<EmpresaDetalhePage />} />
          <Route path="/agenda" element={<AgendaPage />} />
          <Route path="/abertos" element={<AbertosPage />} />
          <Route path="/extracao/google" element={<GoogleExtractionRouteGuard />} />
          <Route path="/kanban" element={<KanbanPage />} />
          <Route path="/busca-ia" element={<BuscaAiPage />} />
          {/* <Route path="/extracao/apolo" element={<ExtracaoApoloPage />} /> */}
          <Route path="/agente" element={<AgentePage />} />
          <Route path="/perfil" element={<PerfilPage />} />
          <Route path="/configuracoes" element={<ConfiguracoesPage />} />
          <Route path="/configurar-whatts" element={<ConfigurarWhattsPage />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
